import { Row, Col, Image } from "react-bootstrap";
import box from '../assets/images/boxes.svg';
import chart from '../assets/images/chart.svg';
import person from '../assets/images/person.svg';
import trusted from '../assets/images/trusted.svg';
import '../assets/scss/pages/home.scss';

function WhyUs() {
    return (
        <Row as="section" className="why bg-primary home-section d-flex px-5 mx-0">
            <Row as="header">
                <h2 className="py-3"><b>WHY YOU</b> SHOULD CHOOSE US</h2>
            </Row>
            <p>We are your trusted partner in finding the perfect property</p>
            <Row xs={1} md={2} xl={3} className="d-flex py-5">
                <Col md={5} className="why-card px-3 py-4 mx-auto mb-3">
                    <h5>Trusted & Transparent Service</h5>
                    <Image src={trusted} className="py-4"/>
                    <p>Integrity and honesty are at the core of everything we do, fostering trust and long-term relationships with all of our clients.</p>
                </Col>
                <Col md={5} className="why-card px-3 py-4 mx-auto mb-3">
                    <h5>Extensive Market Expertise</h5>
                    <Image src={chart} className="py-4" />
                    <p>With in-depth knowledge of the real estate market, we provide insights and data-driven advice that make property transactions smooth and beneficial.</p>
                </Col>
                <Col md={5} className="why-card px-3 py-4 mx-auto mb-3">
                    <h5>Technology-Driven Experience</h5>
                    <Image src={box} className="py-4" />
                    <p>Utilizing cutting-edge tools, we offer a user-friendly experience that simplifies property searches and streamlines communication.</p>
                </Col>
                <Col md={5} className="why-card px-3 py-4 mx-auto mt-xl-3 mt-xxl-3">
                    <h5>Personalized Solutions</h5>
                    <Image src={person} className="py-4" />
                    <p>Every client's needs are unique, and we ensure a custom approach for each buyer to create ideal outcomes.</p>
                </Col>
            </Row>
        </Row>
    )
}

export default WhyUs;
